module.exports = __webpack_public_path__ + "static/img/znzz5.c763238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz5.jpg
// module id = +QQD
// module chunks = 0